var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info_FILL0_wght200_GRAD0_opsz20",
    "data-name": "info FILL0 wght200 GRAD0 opsz20",
    d: "m7.63,12h.74v-5.11h-.74v5.11Zm.37-6.26c.13,0,.25-.05.34-.14.1-.08.15-.2.15-.33,0-.26-.21-.48-.47-.49,0,0-.01,0-.02,0-.13,0-.25.05-.34.14-.1.08-.15.2-.15.33,0,.26.21.48.47.49,0,0,.01,0,.02,0Zm0,10.26c-1.07,0-2.12-.21-3.1-.63-1.92-.82-3.45-2.35-4.27-4.27C.21,10.13,0,9.07,0,8.01c0-1.07.2-2.13.63-3.12C1.46,2.97,2.98,1.45,4.9.63,5.88.21,6.93,0,8,0c1.07,0,2.13.2,3.12.63,1.91.83,3.44,2.35,4.25,4.27.84,1.98.84,4.22,0,6.21-.82,1.92-2.35,3.44-4.26,4.26-.98.42-2.04.64-3.1.63Zm0-.75c1.93.03,3.79-.73,5.14-2.12,1.38-1.35,2.15-3.21,2.12-5.14.03-1.93-.73-3.79-2.12-5.14-1.35-1.38-3.21-2.15-5.14-2.12-1.93-.03-3.79.73-5.14,2.12-1.38,1.35-2.15,3.21-2.12,5.14-.03,1.93.73,3.79,2.12,5.14,1.35,1.38,3.21,2.15,5.14,2.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/Information Icon.c9e3f47326090d6cdd94322a1c5280b9.svg";
export { ForwardRef as ReactComponent };